/**
 * Built-in presentation templates (FreeShow-style).
 *
 * Um template é um pacote de estilo aplicável à apresentação inteira,
 * a um grupo (música) ou a uma página:
 * { background, color, effect }
 *
 * - `background`: '' limpa para o fundo padrão; ou URL de imagem.
 * - `color`: cor do texto ('' = padrão do tema).
 * - `effect`: null = não toca; true/false = força o efeito.
 *
 * Chaves extras de `style` (ex. `fontFamily` do futuro toolbar TipTap)
 * trafegam pelo `style` genérico do configuration sem tratamento especial.
 *
 * O doc v2 pode guardar `templates` customizados do usuário no mesmo formato
 * (com `id` e `name`); esta lista é só o ponto de partida built-in.
 */

export const BUILT_IN_TEMPLATES = [
  {
    id: 'standard',
    labelKey: 'presentation.tplStandard',
    configuration: { background: '', color: '', effect: null },
  },
  {
    id: 'contrast',
    labelKey: 'presentation.tplContrast',
    configuration: { background: '', color: '#FFFFFF', effect: false },
  },
  {
    id: 'warm',
    labelKey: 'presentation.tplWarm',
    configuration: { background: '', color: '#FDE68A', effect: true },
  },
];

export const TEMPLATE_TARGETS = [
  { value: 'all', labelKey: 'presentation.targetAll' },
  { value: 'group', labelKey: 'presentation.targetGroup' },
  { value: 'page', labelKey: 'presentation.targetPage' },
];

export function getTemplate(id) {
  return BUILT_IN_TEMPLATES.find((t) => t.id === id) || null;
}
